<div class="create-dialog-box">
    <div class="title d-flex align-items-center justify-content-space-between">
        <h4 class="mb-0">{{data?.id ? 'Update Folder' : 'Add Folder'}}</h4>
        <button class="close-btn bg-transparent p-0 border-none" (click)="close()"><i class="flaticon-close"></i></button>
    </div>
    <form [formGroup]="folder_form" (ngSubmit)="submit()">
        <div class="form-group">
            <label class="d-block fw-semibold">Folder Name</label>
            <input type="text" class="input-folder-name" placeholder="Please enter folder name" formControlName="name">
            <span class="fs-13 text-danger fw-semibold" *ngIf="submitted && folder_form.get('name').invalid">Folder name is required</span>
        </div>
        <div class="text-end">
            <button type="submit"><i class="ri-add-fill" *ngIf="!data?.id"></i>{{data?.id ? 'Update Folder' : 'Add Folder'}}</button>
        </div>
    </form>
</div>